// extracted by mini-css-extract-plugin
export var tag = "HashTag-module--tag--87100";